//jshint module : true
import ads from '../actions/ads';

const initialState = {
    gpt: null,
    adSenseQuery: '',
    adSenseShoppingPublisherId: ''
};

export default (state = initialState, action) => {
    if (!action || !action.type) return state;
    switch (action.type) {
        case ads.actionTypes.SET_ADS:
            return {
                ...state,
                gpt: action.payload.gpt,
                adSenseQuery: action.payload.adSenseQuery,
                adSenseShoppingPublisherId:
                    action.payload.adSenseShoppingPublisherId
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/reducers/ads.js